export default {"src":"/_next/static/media/poundSign.52caac13.svg","height":21,"width":16,"blurWidth":0,"blurHeight":0};